export default function attribute(url: string, attribution: string) {
  if (attribution) {
    return url.replace('{{attribution}}', attribution);
  }
  return url;
}

